import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

const InfoCircleIcon = React.forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
    <path
      d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

InfoCircleIcon.displayName = 'InfoCircleIcon';

export default InfoCircleIcon;
